module.exports = __webpack_public_path__ + "img/evolution.483ff63c.svg";